import React, { useEffect, useState } from "react";
import { Table } from "rsuite";
import { GetAccountDetails } from "../Services/AccountsDB";
import { GetAccountDropDown, GetFeedBackScreen } from "../Services/KRAApprovalDB";
import { GetProcessDetails } from "../Services/ProcessDB";
import { GetUserLoginID } from "../Services/UserSessionManager";
import { GetSubStateProcess } from "../Services/WeightageDB";
const loginId=GetUserLoginID();

export const CustomTableCell = (props: any) => (
  <Table.Cell
    className="border-bottom border-dark"
    {...props}
    style={{ padding: 4 }}
  />
);

export const EditCell = ({ rowData, dataKey, onChange, ...props }: any) => {
  const editing = rowData.status1 === "EDIT";
  return (
    <Table.Cell
      {...props}
      className={
        editing ? "table-content-editing" : "border-bottom border-dark"
      }
      style={{ padding: 4 }}
    >
      {editing ? (
        <input
          className="rs-input"
          defaultValue={rowData[dataKey]}
          onChange={(event) => {
            onChange && onChange(rowData.ID, dataKey, event.target.value);
          }}
        />
      ) : (
        <span className="table-content-edit-span">{rowData[dataKey]}</span>
      )}
    </Table.Cell>
  );
};

export const EditCellAccountDropdown = ({
  rowData,
  dataKey,
  onChange,
  ...props
}: any) => {
  const editing = rowData.status1 === "EDIT";
  
  const [account, SetAccount] = useState([]);
  useEffect(() => {
    GetAccountName();
  }, []);

  // const GetAccountName = () => {
  //   GetAccountDropDown(rowData["EmployeeID"]).then((res) => {
    
  //     SetAccount(res.data);
  //   });
  // };

  const GetAccountName=()=>{
    GetAccountDetails().then((res)=>{
      SetAccount(res.data)
    })
  }
  if(editing){
    GetAccountName()
  }

  return (
    <Table.Cell
      {...props}
      className={
        editing ? "table-content-editing" : "border-bottom border-dark"
      }
      style={{ padding: 4 }}
    >
      {editing ? (
        // <input
        //   className="rs-input"
        //   defaultValue={rowData[dataKey]}
        //   onChange={(event) => {
        //     onChange && onChange(rowData.ID, dataKey, event.target.value);
        //   }}
        // />

        <select
          id="select"
          name="AccountName"
          style={{ width: "100px" }}
          value={rowData[dataKey]}
          onChange={(event) => {
            onChange && onChange(rowData.ID, dataKey, event.target.value);
          }}
        >
          <option className="bg-secondary text-light">select-Account</option>
          {account.map((a: any) => {
            if (a === null) return <></>;
            else if (a.IsActive === "Active") {
              return <option value={a.AccountName}>{a.AccountName}</option>;
          }
          })}
        </select>
      ) : (
        <span className="table-content-edit-span">{rowData[dataKey]}</span>
      )}
    </Table.Cell>
  );
};

export const EditCellProcessDropdown = ({
  rowData,
  dataKey,
  onChange,
  ...props
}: any) => {
  const editing = rowData.status1 === "EDIT";
  const [process, SetProcess] = useState([]);
  useEffect(() => {
    GetProcessName();
  }, []);

  const GetProcessName = () => {
    GetProcessDetails().then((res) => {
      SetProcess(res.data);
    });
  };

  return (
    <Table.Cell
      {...props}
      className={
        editing ? "table-content-editing" : "border-bottom border-dark"
      }
      style={{ padding: 4 }}
    >
      {editing ? (
        <select
          id="select"
          name="ProcessName"
          style={{ width: "90px" }}
          value={rowData[dataKey]}
          onChange={(event) => {
            //setProcessNameforSubState(event.target.value);
            onChange && onChange(rowData.ID, dataKey, event.target.value);
          }}
        >
          <option className="bg-secondary text-light">Select-Process</option>
          {process.map((p: any) => {
            if (p === null) return <></>;
            else if (p.IsActive === "Active") {
              return <option value={p.ProcessName}>{p.ProcessName}</option>;
            }
          })}
        </select>
      ) : (
        <span className="table-content-edit-span">{rowData[dataKey]}</span>
      )}
    </Table.Cell>
  );
};

export const EditCellSubstateDropdown = ({
  rowData,
  dataKey,
  onChange,
  ...props
}: any) => {

  const editing = rowData.status1 === "EDIT";
  const [subState, SetSubstate] = useState([]);
  const GetSubStateDropdown=()=>{
    
    if (editing) {
    
     
      if (props.processName === "")
        GetSubStateProcess(rowData["ProcessName"]).then((res) => {
          SetSubstate(res.data);
        });
      else {
        GetSubStateProcess(props.processName).then((res) => {
          SetSubstate(res.data);
        });
      }
    }

  }

  useEffect(() => {
    // if (editing) {
    //   if (props.processName === "")
    //     GetSubStateProcess(rowData["ProcessName"]).then((res) => {
    //       SetSubstate(res.data);
    //     });
    //   else {
    //     GetSubStateProcess(props.processName).then((res) => {
    //       SetSubstate(res.data);
    //     });
    //   }
    // }
    GetSubStateDropdown();

  }, [props.processName]);

  useEffect(()=>{
    if(editing)
    GetSubStateDropdown();
  })

  return (
    <Table.Cell
      {...props}
      className={
        editing ? "table-content-editing" : "border-bottom border-dark"
      }
      style={{ padding: 4 }}
    >
      {editing ? (
        <select
          id="select"
          name="SubStateName"
          style={{ width: "100px" }}
          value={rowData[dataKey]}
          onChange={(event) => {
            onChange && onChange(rowData.ID, dataKey, event.target.value);
          }}
        >
          <option className="bg-secondary text-light">Select-Substate</option>
          {subState.map((s: any) => {
            if (s === null){  return <></>}
            else {
              return (
                <option value={s.SubStateName}>
                   {s.SubStateName}
                </option>
              );
            }
          })}
        </select>
      ) : (
        <span className="table-content-edit-span"> {rowData[dataKey]}</span>
      )}
    </Table.Cell>
  );
};

